import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Badge,
  Card,
  Group,
  SegmentedControl,
  Text,
  TextInput,
} from "@mantine/core";

import { PaginatedList } from "@components/shared";

function statusColor(status) {
  if (status === 1) return "green";
  if (status === 2) return "gray";
  if (status === 3) return "red";
  return "gray";
}

function conceptualItemPath(row) {
  if (row.root_id && row.conceptual_item_id) {
    return `/conceptual-roots/${row.root_id}/items/${row.conceptual_item_id}`;
  }
  return null;
}

export default function InstrumentItemList({
  items = [],
  requestInfo = {
    url: `/retrieve-instrument-items/`,
    data: {},
  },
  refresh,
}) {
  const { t } = useTranslation();
  const [filters, setFilters] = useState({
    status: "entire",
    search_value: "",
  });

  const reqData = {
    ...filters,
    ...requestInfo.data,
    refresh,
  };

  return (
    <div>
      <TextInput
        placeholder={t("search")}
        size="lg"
        value={filters.search_value}
        onChange={(e) =>
          setFilters({ ...filters, search_value: e.target.value })
        }
      />
      <SegmentedControl
        data={[
          { label: t("all"), value: "entire" },
          { label: t("active"), value: "active" },
          { label: t("inactive"), value: "inactive" },
        ]}
        value={filters.status}
        onChange={(value) => setFilters({ ...filters, status: value })}
        mt="sm"
        size="xs"
      />
      <PaginatedList
        tableData={items}
        requestInfo={{
          url: requestInfo.url,
          data: reqData,
        }}
        responseMapping={(rows) =>
          rows.map((row) => ({
            ...row,
            link_url: conceptualItemPath(row),
          }))
        }
        displayFormatter={(item) => {
          const row = item.original;
          const path = conceptualItemPath(row);
          const title = (
            <Text c="dark" fw={700} component={path ? Link : "span"} to={path}>
              {row.interrogative || row.id}
            </Text>
          );

          return (
            <Card key={row.id}>
              <Group justify="space-between" align="flex-start">
                <div>
                  {title}
                  {(row.root_label || row.conceptual_item_label) && (
                    <Text size="sm" c="dimmed">
                      {[row.root_label, row.conceptual_item_label]
                        .filter(Boolean)
                        .join(" · ")}
                    </Text>
                  )}
                  {row.legacy_question_code && (
                    <Text size="xs" c="dimmed">
                      {row.legacy_question_code}
                    </Text>
                  )}
                </div>
                {row.status_formatted && (
                  <Badge color={statusColor(row.status)} variant="light">
                    {row.status_formatted}
                  </Badge>
                )}
              </Group>
            </Card>
          );
        }}
      />
    </div>
  );
}
